import { render } from "./balance-sheet.vue?vue&type=template&id=4baef9b2&scoped=true"
import script from "./balance-sheet.vue?vue&type=script&lang=js"
export * from "./balance-sheet.vue?vue&type=script&lang=js"

import "./balance-sheet.vue?vue&type=style&index=0&id=4baef9b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baef9b2"]])

export default __exports__